import Vue from "vue";

Vue.mixin({
    methods: {
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onload = () => resolve(window.btoa(reader.result));
                reader.onerror = error => reject(error);
            });
        }
    }
});

import "@/assets/css/styles.css";

// Bootstrap Vue
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/material-dashboard.min.css";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

import "@/assets/template/css/animate.css";
import "@/assets/template/css/style.css";

// Custom Components
import FormButtons from "@/components/includes/FormButtons.vue";
Vue.component("form-buttons", FormButtons);
import IndexButtons from "@/components/includes/IndexButtons.vue";
Vue.component("index-buttons", IndexButtons);

// Select Component
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multi-select", Multiselect);

import { ModelSelect, ModelListSelect, MultiListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css"
Vue.component("model-select", ModelSelect);
Vue.component("model-list-select", ModelListSelect);
Vue.component("multi-list-select", MultiListSelect);

// DatePicker Component
import DatePicker from "vue2-datepicker";
Vue.use(DatePicker);

// Vue Moment
const moment = require('moment-timezone')
moment.tz.setDefault('GMT')
import VueMoment from 'vue-moment';
require('moment/locale/pt-br')

Vue.use(VueMoment, { moment });

// Vue Material
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
Vue.use(VueMaterial);

// Vue Notify
import Notify from "vue2-notify";
Vue.use(Notify, {position: "top-right", visibility: 1000});

// Vue Dialog
import VuejsDialog from "vuejs-dialog";
Vue.use(VuejsDialog);

// Vue Mask
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

import money from "v-money";
Vue.use(money, {precision: 4});

// Vue Upload
import FileUpload from "vue-upload-component";
Vue.component("file-upload", FileUpload);

// Routes
import router from "./router";
Vue.use(router);

// Flash Message
import VueFlashMessage from "vue-flash-message";
Vue.use(VueFlashMessage);

// Stores
import store from "./stores";

// Filters
import { Directives } from "./directives";
Directives();

// Filters
import { Filters } from "./filters";
Filters();

// Api
import ApiService from "./services/api.service";
ApiService.init();

// Crawler
import CrawlerService from "./services/crawler.service";
CrawlerService.init();

// Loader
import { RingLoader } from "@saeris/vue-spinners";
Vue.component("ring-loader", RingLoader);

// Configurations
Vue.config.productionTip = false;

import CKEditor from "@ckeditor/ckeditor5-vue";
CKEditor.component.props.config = {
    config: {
        extraPlugins: [
            function (editor) {
                console.log(editor);
            }
        ]
    }
};
Vue.use(CKEditor);

import VeeValidate from "vee-validate";
import ptBR from "vee-validate/dist/locale/pt_BR";

Vue.use(VeeValidate, {
    fieldsBagName: "veeFields",
    locale: "pt_BR",
    inject: false,
    dictionary: {
        pt_BR: {
            messages: {
                required: () => "Campo obrigatório",
                email: () => "E-mail inválido",
                min: (field, [length]) => "Tamanho mínimo " + length,
                mimes: () => "Arquivo inválido"
            }
        }
    }
});

import VueApexCharts from "vue-apexcharts";
Vue.component("apexchart", VueApexCharts)

import CKEditorComponent from "@/components/CKEditor";
Vue.component("ckeditor-component", CKEditorComponent);

import Quill from "@/components/Quill";
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.component("quill", Quill);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/pt-br";

// configure language
locale.use(lang);

Vue.use(ElementUI);

// App
import App from "./App.vue";
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
